var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary float-right","dark":""},on:{"click":function($event){return _vm.downloadExcel()}}},[_vm._v(" Exportar ")])
}
var staticRenderFns = []

export { render, staticRenderFns }